(() => {
    const DEFAULT_TIMEOUT = 10000;

    const withTimeout = async (promise, timeoutMs = DEFAULT_TIMEOUT) => {
        let timeoutId;
        const timeoutPromise = new Promise((_, reject) => {
            timeoutId = setTimeout(() => reject(new Error(`Request timeout after ${timeoutMs}ms`)), timeoutMs);
        });

        try {
            return await Promise.race([promise, timeoutPromise]);
        } finally {
            clearTimeout(timeoutId);
        }
    };

    const toQueryString = (data) => {
        if (!data) return '';
        if (typeof data === 'string') return data;
        if (data instanceof URLSearchParams) return data.toString();
        if (typeof data === 'object') {
            return new URLSearchParams(data).toString();
        }

        return String(data);
    };

    const request = async ({
        url,
        method = 'GET',
        data,
        timeout = DEFAULT_TIMEOUT,
        headers = {},
        credentials = 'same-origin'
    }) => {
        const normalizedMethod = method.toUpperCase();
        const hasBody = normalizedMethod !== 'GET' && normalizedMethod !== 'HEAD';
        let requestUrl = url;
        const options = {
            method: normalizedMethod,
            headers: { ...headers },
            credentials
        };

        if (!hasBody && data !== undefined) {
            const query = toQueryString(data);
            if (query) {
                requestUrl += requestUrl.includes('?') ? `&${query}` : `?${query}`;
            }
        } else if (hasBody && data !== undefined) {
            if (typeof data === 'string') {
                options.body = data;
                if (!options.headers['Content-Type']) {
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
                }
            } else if (data instanceof URLSearchParams) {
                options.body = data.toString();
                if (!options.headers['Content-Type']) {
                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
                }
            } else if (typeof data === 'object') {
                options.body = JSON.stringify(data);
                if (!options.headers['Content-Type']) {
                    options.headers['Content-Type'] = 'application/json';
                }
            } else {
                options.body = String(data);
            }
        }

        const response = await withTimeout(fetch(requestUrl, options), timeout);
        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
            return response.json();
        }

        const text = await response.text();
        try {
            return JSON.parse(text);
        } catch (_) {
            return text;
        }
    };

    const requestWebbeePricing = (requestPayload, timeout = DEFAULT_TIMEOUT) => {
        return request({
            url: 'https://hooks.webbeeglobal.com/NetsuiteSuitetalkWeb/quantity-pricing/product',
            method: 'GET',
            data: encodeURIComponent(JSON.stringify(requestPayload)),
            timeout
        });
    };

    const parseProductValues = (responseData) => {
        if (!responseData || !responseData.productValues || responseData.productValues === 'null') {
            return null;
        }

        return JSON.parse(responseData.productValues);
    };

    window.WebbeeAPI = {
        request,
        requestWebbeePricing,
        parseProductValues
    };
})();
